import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconWorkflowShapes24(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={24}
            height={24}
            className={customClassName}
            name="IconWorkflowShapes24"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M19.425 7.303a.5.5 0 0 0 0-.707l-2.122-2.12a.5.5 0 0 0-.707 0l-2.121 2.12a.5.5 0 0 0 0 .707l2.121 2.122a.5.5 0 0 0 .707 0zm1.06 1.061a2 2 0 0 0 0-2.828l-2.121-2.122a2 2 0 0 0-2.828 0l-2.122 2.122c-.21.21-.363.454-.46.714H10.93a4.001 4.001 0 1 0-4.68 4.68V13H5a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h4a2 2 0 0 0 2-2v-4a2 2 0 0 0-2-2H7.75v-2.07a4 4 0 0 0 3.18-3.18h2.065c.097.223.237.432.42.614l2.12 2.121c.21.21.454.363.715.46v2.125A4.001 4.001 0 0 0 17 21a4 4 0 0 0 .75-7.93v-2.165c.223-.098.432-.237.614-.42zM9.5 15a.5.5 0 0 0-.5-.5H5a.5.5 0 0 0-.5.5v4a.5.5 0 0 0 .5.5h4a.5.5 0 0 0 .5-.5zm0-8a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0M17 19.5a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconWorkflowShapes24);
